import { z } from "zod";

/**
 * Per-(inclusionStatus, filterParam) exclusion-reason counts on the lean list info, feeding
 * the grouped "Show" dropdown's reason sub-rows (PREC-3536 Phase 5). `count` is a SQL
 * aggregate — it arrives as a string at runtime, so it is coerced at the schema boundary
 * (web rule §6).
 */
export const ExclusionReasonCountSchema = z.object({
	inclusionStatus: z.string(),
	filterParam: z.string(),
	count: z.coerce.number(),
});

export type ExclusionReasonCount = z.infer<typeof ExclusionReasonCountSchema>;
